import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPasswordPage({ csrfToken }) {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const res = await fetch('/auth/forgot-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-csrf-token': csrfToken,
                },
                body: JSON.stringify({ email }),
            });

            const data = await res.json();
            if (!res.ok) {
                setError(data.error || 'Something went wrong');
                setLoading(false);
                return;
            }

            setSent(true);
        } catch {
            setError('Something went wrong. Please try again.');
            setLoading(false);
        }
    }

    if (sent) {
        return (
            <AuthLayout>
                <h1 className='text-lg font-semibold text-white mb-3'>Check your email</h1>
                <p className='text-sm text-[#ffffff99] mb-5'>
                    If an account exists for <span className='text-white font-medium'>{email}</span>,
                    you'll receive a password reset link shortly.
                </p>
                <Link to='/login' className='action-button w-full text-center'>
                    Back to sign in
                </Link>
            </AuthLayout>
        );
    }

    return (
        <AuthLayout>
            <h1 className='text-lg font-semibold text-white mb-2'>Reset password</h1>
            <p className='text-sm text-[#ffffff99] mb-5'>
                Enter your email and we'll send you a link to reset your password.
            </p>

            {error && (
                <div className='mb-4 p-3 rounded-lg bg-red-900/30 border border-red-800 text-red-300 text-sm'>
                    {error}
                </div>
            )}

            <form onSubmit={handleSubmit} className='flex flex-col gap-3'>
                <input
                    type='email'
                    placeholder='Email'
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className='input'
                    required
                    autoFocus
                />

                <button type='submit' className='action-button w-full mt-1' disabled={loading}>
                    {loading ? 'Sending...' : 'Send reset link'}
                </button>
            </form>

            <p className='mt-5 text-center text-sm text-[#ffffff66]'>
                <Link to='/login' className='text-mainblue-500 hover:text-mainblue-400 font-medium'>Back to sign in</Link>
            </p>
        </AuthLayout>
    );
}

function AuthLayout({ children }) {
    return (
        <div className='min-h-dvh flex-grow flex-center bg-[#1e1e1e] p-4'>
            <div className='w-full max-w-[400px] flex flex-col items-center'>
                <img src='/static/images/jpegmini-icon.png' width='48' height='48' className='mb-6' />

                <div className='form-block w-full'>
                    {children}
                </div>
            </div>
        </div>
    );
}
